exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1QDTZfBsizkS8O4Jej5a3A{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;position:relative}html[dir] ._1QDTZfBsizkS8O4Jej5a3A:focus{border:dotted 1px}", ""]);
// Exports
exports.locals = {
	"showTabBar": "_1QDTZfBsizkS8O4Jej5a3A"
};